let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jYEAu")).then(() => parcelRequire('dej0b'));